<template>
  <BreadCrumb PageTitle="Continuer une session" />
  <ContinuerSession />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ContinuerSession from "@/components/Session/ContinuerSession.vue";

export default defineComponent({
  name: "ContinuerSessionPage",
  components: {
    BreadCrumb,
    ContinuerSession,
  },
});
</script>